import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import InfraNav from './components/InfraNav';
import InfraFooter from './components/InfraFooter';
import './infrastructure.css';

export default function InfrastructureDevelopers() {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <div className="infra-page" data-testid="infrastructure-developers">
      <InfraNav transparent={false} />

      {/* FULL-PAGE DARK SECTION */}
      <div className="infra-devpage" data-testid="devpage-hero">

        {/* HEADLINE */}
        <div className="infra-devpage-header">
          <h1 className="infra-devpage-headline">
            <span className="infra-devpage-bold">Choose an integration path.</span>{' '}
            <span className="infra-devpage-muted">With clean APIs, pre-built connectors, and a no-code dashboard, you can quickly get started with the best option for your business.</span>
          </h1>
        </div>

        {/* THREE CARDS */}
        <div className="infra-devpage-cards" data-testid="devpage-cards">

          {/* Card 1: Dashboard / No-Code */}
          <div className="infra-devpage-card" data-testid="devpage-card-dashboard">
            <div className="infra-devpage-card-visual infra-devpage-visual-dashboard">
              <div className="infra-devpage-dash-topbar">
                <div className="infra-devpage-dash-dot" style={{background:'#ff5f57'}} />
                <div className="infra-devpage-dash-dot" style={{background:'#febc2e'}} />
                <div className="infra-devpage-dash-dot" style={{background:'#28c840'}} />
                <span className="infra-devpage-dash-url">app.pebbles.financial/dashboard</span>
              </div>
              <div className="infra-devpage-dash-body">
                <div className="infra-devpage-dash-sidebar">
                  <div className="infra-devpage-dash-sidebar-item infra-devpage-dash-sidebar-active">Payroll</div>
                  <div className="infra-devpage-dash-sidebar-item">Wallets</div>
                  <div className="infra-devpage-dash-sidebar-item">Collect</div>
                  <div className="infra-devpage-dash-sidebar-item">Team</div>
                  <div className="infra-devpage-dash-sidebar-item">Settings</div>
                </div>
                <div className="infra-devpage-dash-main">
                  <div className="infra-devpage-dash-heading">Run payroll</div>
                  <div className="infra-devpage-dash-row">
                    <div className="infra-devpage-dash-field">
                      <span className="infra-devpage-dash-label">Employees</span>
                      <span className="infra-devpage-dash-value">24</span>
                    </div>
                    <div className="infra-devpage-dash-field">
                      <span className="infra-devpage-dash-label">Total</span>
                      <span className="infra-devpage-dash-value">{'\u20A6'}4.2M</span>
                    </div>
                  </div>
                  <div className="infra-devpage-dash-btn">Process payroll</div>
                  <div className="infra-devpage-dash-status">
                    <span className="infra-devpage-dash-status-dot" />{' '}Last run: Mar 1 — Completed
                  </div>
                </div>
              </div>
            </div>
            <div className="infra-devpage-card-text">
              <p><span className="infra-devpage-card-bold">No code required.</span> Run payroll, issue wallets, manage collections and view compliance reports directly from the Pebbles Dashboard.</p>
              <Link to="/login" className="infra-devpage-card-cta" data-testid="devpage-cta-dashboard">Open dashboard &rsaquo;</Link>
            </div>
          </div>

          {/* Card 2: Partner Integrations */}
          <div className="infra-devpage-card" data-testid="devpage-card-partners">
            <div className="infra-devpage-card-visual infra-devpage-visual-partners">
              <div className="infra-devpage-partner-grid">
                {[
                  { name: 'BambooHR', color: '#73c41d', letter: 'B' },
                  { name: 'Workday', color: '#0075c9', letter: 'W' },
                  { name: 'Slack', color: '#611f69', letter: 'S' },
                  { name: 'Xero', color: '#13b5ea', letter: 'X' },
                  { name: 'QuickBooks', color: '#2ca01c', letter: 'Q' },
                  { name: 'Gusto', color: '#f45d48', letter: 'G' },
                  { name: 'Zoho', color: '#e42527', letter: 'Z' },
                  { name: 'SAP', color: '#008fd3', letter: 'S' },
                  { name: 'Freshteam', color: '#ff6f2c', letter: 'F' },
                  { name: 'Rippling', color: '#ffd100', letter: 'R' },
                  { name: 'HiBob', color: '#ff4081', letter: 'H' },
                  { name: 'Personio', color: '#4a56db', letter: 'P' },
                ].map((p, i) => (
                  <div key={i} className="infra-devpage-partner-tile">
                    <div className="infra-devpage-partner-icon" style={{ background: p.color }}>{p.letter}</div>
                    <span className="infra-devpage-partner-name">{p.name}</span>
                  </div>
                ))}
              </div>
            </div>
            <div className="infra-devpage-card-text">
              <p><span className="infra-devpage-card-bold">Use a pre-built connector.</span> Browse our directory of HR, accounting, and payroll platforms that integrate with Pebbles out of the box.</p>
              <span className="infra-devpage-card-cta">See integrations &rsaquo;</span>
            </div>
          </div>

          {/* Card 3: API / Code */}
          <div className="infra-devpage-card" data-testid="devpage-card-api">
            <div className="infra-devpage-card-visual infra-devpage-visual-code">
              <div className="infra-devpage-code-editor">
                <div className="infra-devpage-code-lines">
                  <pre>
<span className="infra-devpage-ln">1</span>  <span className="infra-syn-kw">const</span> pebbles = <span className="infra-syn-fn">require</span>(<span className="infra-syn-str">'pebbles'</span>)(
{'\n'}<span className="infra-devpage-ln">2</span>    <span className="infra-syn-str">'sk_test_abc123'</span>
{'\n'}<span className="infra-devpage-ln">3</span>  );
{'\n'}<span className="infra-devpage-ln">4</span>
{'\n'}<span className="infra-devpage-ln">5</span>  <span className="infra-syn-kw">await</span> pebbles.payroll.<span className="infra-syn-fn">run</span>({'{'}
{'\n'}<span className="infra-devpage-ln">6</span>    company: <span className="infra-syn-str">'comp_thco'</span>,
{'\n'}<span className="infra-devpage-ln">7</span>    month: <span className="infra-syn-str">'2026-03'</span>
{'\n'}<span className="infra-devpage-ln">8</span>  {'}'});
                  </pre>
                </div>
                <div className="infra-devpage-code-autocomplete">
                  <div className="infra-devpage-ac-item">payroll.run</div>
                  <div className="infra-devpage-ac-item">payroll.preview</div>
                  <div className="infra-devpage-ac-item infra-devpage-ac-highlight">wallets.create</div>
                  <div className="infra-devpage-ac-item">wallets.fund</div>
                  <div className="infra-devpage-ac-item">collect.subscribe</div>
                  <div className="infra-devpage-ac-item">comply.verify</div>
                </div>
                <div className="infra-devpage-code-terminal">
                  <div className="infra-devpage-term-bar">
                    <span className="infra-devpage-term-label">TERMINAL</span>
                    <span className="infra-devpage-term-file">server.js</span>
                  </div>
                  <div className="infra-devpage-term-body">
                    <div>$ node server.js &amp;&amp; pebbles listen</div>
                    <div className="infra-devpage-term-ready">&gt; Ready! Waiting for webhooks...</div>
                  </div>
                </div>
              </div>
            </div>
            <div className="infra-devpage-card-text">
              <p><span className="infra-devpage-card-bold">Build your own integration.</span> Use our SDKs, REST APIs, webhooks, and sandbox environment to build and maintain a custom integration.</p>
              <span className="infra-devpage-card-cta">Read the docs &rsaquo;</span>
            </div>
          </div>
        </div>

        {/* BOTTOM SECTION: WHY BUILD ON PEBBLES */}
        <div className="infra-devpage-why" data-testid="devpage-why">
          <h2 className="infra-devpage-why-headline">Why developers choose Pebbles</h2>
          <div className="infra-devpage-why-grid">
            {[
              { title: 'Clean REST APIs', desc: 'Consistent JSON responses, predictable error codes, and comprehensive endpoint documentation.' },
              { title: 'Webhooks for everything', desc: 'Get real-time notifications for payroll runs, transfers, collection events, and compliance updates.' },
              { title: 'Sandbox environment', desc: 'Test every flow with sandbox credentials. No real money moves until you are ready to go live.' },
              { title: 'SDKs in every language', desc: 'Official libraries for Node.js, Python, Ruby, Go, and PHP. Get started in minutes, not days.' },
              { title: 'Idempotency built in', desc: 'Every write endpoint supports idempotency keys. Retry safely without duplicating transactions.' },
              { title: 'Enterprise-grade security', desc: 'SOC 2 compliant, end-to-end encryption, and role-based access controls on every API key.' },
            ].map((item, i) => (
              <div key={i} className="infra-devpage-why-card">
                <div className="infra-devpage-why-title">{item.title}</div>
                <div className="infra-devpage-why-desc">{item.desc}</div>
              </div>
            ))}
          </div>
        </div>

        {/* CTA */}
        <div className="infra-devpage-bottom-cta" data-testid="devpage-bottom-cta">
          <h2 className="infra-devpage-bottom-headline">Start building on Pebbles today.</h2>
          <p className="infra-devpage-bottom-desc">Create a free account, get API keys, and start integrating in minutes.</p>
          <div className="infra-devpage-bottom-buttons">
            <Link to="/login" className="infra-btn-primary">Get started</Link>
            <a href="mailto:hello@pebbles.financial" className="infra-btn-secondary">Contact sales</a>
          </div>
        </div>
      </div>

      <InfraFooter />
    </div>
  );
}
